import { GaleriaImagenes } from './GaleriaImagenes';
import { imagenesSeccionGaleria } from '../data/data';
import { useMobileDetection } from '../hook/useMobileDetection';

import Swal from 'sweetalert2'

import Carousel from './common/Carousel'

export const GaleriaPage = () => {

    const openImage = (url) => {
        Swal.fire({
            width:"max-content",            
            html:`
            <div class="p-3" style="max-height:80vh; overflow:auto;">
                <img src="${url}" style="width:60vw; border-radius:8px;"></img>
            </div>
            `,
            showConfirmButton:false,
            showCloseButton:true
        })
    }

    const isMobile = useMobileDetection();
    return(
        <div className='container' style={{paddingTop:"94px"}}>
            <div className='galery-masonry py-5'>
            {/* <Carousel imagenesCarousel={imagenesSeccionGaleria}/> */}
            {imagenesSeccionGaleria.map(imagen=>
                <div className='masonry-item' onClick={()=>openImage(imagen.url)}>
                    <img src={imagen.url}/>
                </div>
            )}
            </div>
        </div>
    )    
}
